import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const GiverApi = createAsyncThunk("giver/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}givers/get-givers`);
		return data;
	} catch (err) {
		return err.message;
	}
});
